import * as React from 'react';
import { Grid, Box } from '@moonpig/launchpad-components';
import { BlockItem } from '../BlockItem/BlockItem';
export var BlockLayoutH = function BlockLayoutH(_ref) {
  var items = _ref.items;
  return React.createElement(Grid, {
    gap: true
  }, items.map(function (item, i) {
    return React.createElement(Box, {
      key: i,
      width: {
        xs: 1,
        md: 1 / 2
      }
    }, React.createElement(BlockItem, item));
  }));
};